import { Component } from '@angular/core';

@Component({
  selector: 'app-smart-fix-feedback-modal',
  imports: [],
  templateUrl: './smart-fix-feedback-modal.html',
  styleUrls: ['./smart-fix-feedback-modal.scss', '../../../smart-fix-gen-ai/utils/modal-styles.scss'],
})
export class SmartFixFeedbackModal {
  constructor() {}
}
